import {
  SendUserActivityInput,
  useSendUserActivityMutation,
} from '../../../__generated__/graphqlApi';
import { DateTime } from 'luxon';
import useSelectMeProp from '../../../../hooks/selector/useSelectMeProp';
import { useCallback } from 'react';
import Logger from '../../../../utils/core/Logger';
import { getGoogleAnalyticsClientId } from '@firebase/analytics';
import { analytics } from '../../../../firebase-messaging-sw';

export const useSendUserActivity = () => {
  const [mutation] = useSendUserActivityMutation();
  const userId = useSelectMeProp('id');
  return {
    sendUserActivity: useCallback(
      async (input: {
        contentId?: SendUserActivityInput['contentId'];
        djUserId?: SendUserActivityInput['djUserId'];
        eventId: SendUserActivityInput['eventId'];
        marketId?: SendUserActivityInput['marketId'];
        matchId?: SendUserActivityInput['matchId'];
        metadata?: SendUserActivityInput['metadata'];
        profileIds?: SendUserActivityInput['profileIds'];
        sportId?: SendUserActivityInput['sportId'];
      }) => {
        const user_pseudo_id = await getGoogleAnalyticsClientId(analytics);
        mutation({
          variables: {
            input: {
              contentId: input.contentId || null,
              categoryId: null,
              djUserId: input.djUserId || null,
              eventId: input.eventId,
              marketId: input.marketId || null,
              matchId: input.matchId || null,
              metadata: input.metadata || null,
              profileIds: input.profileIds || null,
              sportId: input.sportId || null,
              timestamp: DateTime.local().toISO() || '',
              userId: userId || null,
              user_pseudo_id: user_pseudo_id || null,
            },
          },
        }).catch(error => Logger.error(error));
      },
      [mutation, userId],
    ),
  };
};

export default useSendUserActivity;
